module.exports = __webpack_public_path__ + "static/media/10.99492839.jpg";